module.exports = __webpack_public_path__ + "img/banking-and-finance.8831918a.webp";